
export function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export function formatter(string) {

    const exceptions = {
        seat: 'SEAT',
        bmw: 'BMW',
        citroen: 'Citroën',
        megane: 'Mégane',
        zoe_r90: 'ZOE+R90',
        zoe: 'ZOE'
    }

    // Use to capitalize letters in certain cases
    // however hyundai will be lowecased
    const pattern = {
        volvo: /[a-zA-Z]{1,2}[0-9]{1,}/g, // S90, XC40 etc även A6, Q3 
        ford: /^[a-zA-Z]{1}-[a-zA-Z]{1}/g, // S-Max
        honda: /[a-zA-Z]{2}-[a-zA-Z0-9]{1}/g, // CX-9, HR-V
        fiat: /[0-9]{2,4}[a-zA-Z0-9]{1,2}/g, // 500X
        hyundai: /(i|I)[0-9]+/g // i30 etc
    }

    function strip(string) {

        const from = "åàáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
        const to = "aaaaaaeeeeiiiioooouuuunc------";

        for (var i = 0, l = from.length; i < l; i++) {
            string = string.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
        }
        return string.replace(/[^a-z0-9 -]/g, "");
    }

    return {
        // Takes a model/manufacturer name and converts to a slug
        url: function(){
            let result = Object.keys(exceptions).find(key => exceptions[key] === string) || strip(string.toLowerCase());

            // Replace any spaces with hyphens
            result = result.replace(/\s+/g, '-');

            return result;
        },
        // Takes a model/manufacturer slug and converts to the named query
        query: function(){
            if(exceptions[string] !== undefined) {
                return exceptions[string];
            } else {
                return capitalize(string)
                        .replace(pattern.volvo, match => match.toUpperCase() )
                        .replace(pattern.ford, match => match.toUpperCase() )
                        .replace(pattern.honda, match => match.toUpperCase() )
                        .replace(pattern.fiat, match => match.toUpperCase() )
                        .replace(pattern.hyundai, match => match.toLowerCase() );
            }
        }
    }
}